import React, { lazy } from 'react'
import AppLayout from '../layouts/App'
import { Loadable } from './../components/Main'

// DASHBOARD
const Home = Loadable(lazy(() => import('./../containers/home/Home')))

// RFQ
const RFQIndex = Loadable(lazy(() => import('./../containers/rfq/RFQIndex')))
const RFQCreateIndex = Loadable(lazy(() => import('./../containers/rfq/create/RFQCreateIndex')))
const RFQEditIndex = Loadable(lazy(() => import('./../containers/rfq/edit/RFQEditndex')))
const RFQDetailIndex = Loadable(lazy(() => import('./../containers/rfq/detail/RFQDetailIndex')))

// ORDER
const OrderIndex = Loadable(lazy(() => import('./../containers/order/OrderIndex')))
const OrderViewIndex = Loadable(lazy(() => import('./../containers/order/view/OrderViewIndex')))
const OrderShippingIndex = Loadable(
  lazy(() => import('./../containers/order/shipping/shipping-header/OrderShippingIndex')),
)
const OrderShippingCreate = Loadable(
  lazy(() => import('./../containers/order/shipping/shipping-header/OrderShippingCreate')),
)
const OrderShippingView = Loadable(
  lazy(() => import('./../containers/order/shipping/shipping-header/OrderShippingView')),
)

const OrderCorrectionIndex = Loadable(
  lazy(() => import('./../containers/order/correction/OrderCorrectionIndex')),
)
const OrderCorrectionCreate = Loadable(
  lazy(() => import('./../containers/order/correction/OrderCorrectionCreate')),
)
const OrderCorrectionView = Loadable(
  lazy(() => import('./../containers/order/correction/OrderCorrectionView')),
)

const OrderReturnIndex = Loadable(
  lazy(() => import('./../containers/order/return/OrderReturnIndex')),
)

const ReturnIndex = Loadable(lazy(() => import('./../containers/return/ReturnIndex')))
const ReturnBalanceIndex = Loadable(
  lazy(() => import('./../containers/return/balance/ReturnBalanceIndex')),
)

// LOGISTIC
const WarehouseIndex = Loadable(
  lazy(() => import('./../containers/logistic/warehouse/WarehouseIndex')),
  lazy(() => import('./../containers/logistic/warehouse/create/WarehouseCreate')),
  lazy(() => import('./../containers/logistic/warehouse/edit/WarehouseEdit')),
)

// PRODUCT
const ProductCreate = Loadable(lazy(() => import('./../containers/product/create/ProductCreate')))
const ProductDetail = Loadable(lazy(() => import('../containers/product/detail/ProductDetail')))
const ProductEdit = Loadable(lazy(() => import('./../containers/product/edit/ProductEdit')))
const ProductIndex = Loadable(lazy(() => import('./../containers/product/ProductIndex')))
const ProductReview = Loadable(
  lazy(() => import('./../containers/product/detail/review/ProductReview')),
)

//WAREHOUSE
const WarehouseEdit = Loadable(
  lazy(() => import('../containers/logistic/warehouse/edit/WarehouseEdit')),
)
const WarehouseDetail = Loadable(
  lazy(() => import('./../containers/logistic/warehouse/detail/WarehouseDetail')),
)
const WarehouseCreate = Loadable(
  lazy(() => import('./../containers/logistic/warehouse/create/WarehouseCreate')),
)

// FUND
const BankCreate = Loadable(lazy(() => import('./../containers/fund/bank/create/BankCreate')))
const BankEdit = Loadable(lazy(() => import('./../containers/fund/bank/edit/BankEdit')))
const BankIndex = Loadable(lazy(() => import('./../containers/fund/bank/BankIndex')))
const FundBalanceIndex = Loadable(
  lazy(() => import('./../containers/fund/balance/FundBalanceIndex')),
)
const FundEscrowHistoryIndex = Loadable(
  lazy(() => import('./../containers/fund/escrow/FundEscrowHistoryIndex')),
)
const FundWithdrawalHistoryIndex = Loadable(
  lazy(() => import('./../containers/fund/withdraw/history/FundWithdrawalHistoryIndex')),
)
const FundWithdrawalIndex = Loadable(
  lazy(() => import('./../containers/fund/withdraw/FundWithdrawalIndex')),
)

//ACCOUNT
const CompanyInformationIndex = Loadable(
  lazy(() => import('../containers/account/company/CompanyProfileIndex')),
)
const ProfileIndex = Loadable(lazy(() => import('../containers/account/profile/ProfileIndex')))
const SettingIndex = Loadable(lazy(() => import('../containers/account/setting/SettingIndex')))
const ChangePasswordIndex = Loadable(
  lazy(() => import('../containers/account/setting/ChangePasswordIndex')),
)

// NOTIFICATION
const Notification = Loadable(lazy(() => import('../containers/notification/NotificationIndex')))

// CHAT
const Chat = Loadable(lazy(() => import('./../containers/chat/Chat')))

// Bill
const FundBillCreate = Loadable(
  lazy(() => import('./../containers/fund/bill/create/FundBillCreate')),
)

const FundBillDownPaymentCreate = Loadable(
  lazy(() => import('./../containers/fund/bill-shipping/create/FundBillDownPaymentCreate')),
)

const FundBillShippingCreate = Loadable(
  lazy(() => import('./../containers/fund/bill-shipping/create/FundBillShippingCreate')),
)

const FundBillRegenerate = Loadable(
  lazy(() => import('./../containers/fund/bill/regenerate/FundBillRegenerate')),
)

const MainRoutes = {
  path: '/',
  element: <AppLayout />,
  children: [
    {
      path: '/',
      element: <Home />,
    },
    {
      path: '/account/store',
      element: <ProfileIndex />,
    },
    {
      path: '/account/company',
      element: <CompanyInformationIndex />,
    },
    {
      path: '/account/settings',
      element: <SettingIndex />,
    },
    {
      path: '/account/settings/password',
      element: <ChangePasswordIndex />,
    },
    {
      path: '/rfq',
      element: <RFQIndex />,
    },
    {
      path: '/rfq/create',
      element: <RFQCreateIndex />,
    },
    {
      path: '/rfq/detail',
      element: <RFQDetailIndex />,
    },
    {
      path: '/rfq/edit',
      element: <RFQEditIndex />,
    },
    {
      path: '/order',
      element: <OrderIndex />,
    },
    {
      path: '/order/view',
      element: <OrderViewIndex />,
    },
    {
      path: '/order/shipping',
      element: <OrderShippingIndex />,
    },
    {
      path: '/order/shipping/create',
      element: <OrderShippingCreate />,
    },
    {
      path: '/order/shipping/view',
      element: <OrderShippingView />,
    },
    {
      path: '/order/correction',
      element: <OrderCorrectionIndex />,
    },
    {
      path: '/order/correction/create',
      element: <OrderCorrectionCreate />,
    },
    {
      path: '/order/correction/view',
      element: <OrderCorrectionView />,
    },
    {
      path: '/order/return',
      element: <OrderReturnIndex />,
    },
    {
      path: '/return',
      element: <ReturnIndex />,
    },
    {
      path: '/return/balance',
      element: <ReturnBalanceIndex />,
    },
    {
      path: '/logistic/warehouse',
      element: <WarehouseIndex />,
    },
    {
      path: '/logistic/warehouse/detail',
      element: <WarehouseDetail />,
    },
    {
      path: '/logistic/warehouse/create',
      element: <WarehouseCreate />,
    },
    {
      path: '/logistic/warehouse/edit',
      element: <WarehouseEdit />,
    },
    {
      path: '/product',
      element: <ProductIndex />,
    },
    {
      path: '/product/create',
      element: <ProductCreate />,
    },
    {
      path: '/product/edit',
      element: <ProductEdit />,
    },
    {
      path: '/product/detail',
      element: <ProductDetail />,
    },
    {
      path: '/product/review',
      element: <ProductReview />,
    },
    {
      path: '/fund/balance',
      element: <FundBalanceIndex />,
    },
    {
      path: '/fund/escrow',
      element: <FundEscrowHistoryIndex />,
    },
    {
      path: '/fund/bank',
      element: <BankIndex />,
    },
    {
      path: '/fund/bank/create',
      element: <BankCreate />,
    },
    {
      path: '/fund/bank/edit',
      element: <BankEdit />,
    },
    {
      path: '/fund/withdraw',
      element: <FundWithdrawalIndex />,
    },
    {
      path: '/fund/withdraw/history',
      element: <FundWithdrawalHistoryIndex />,
    },
    {
      path: '/notification',
      element: <Notification />,
    },
    {
      path: '/chat',
      element: <Chat />,
    },
    {
      path: '/bill/create',
      element: <FundBillCreate />,
    },
    {
      path: '/bill-dp/create',
      element: <FundBillDownPaymentCreate />,
    },
    {
      path: '/bill-shipping/create',
      element: <FundBillShippingCreate />,
    },
    {
      path: '/bill/regenerate',
      element: <FundBillRegenerate />,
    },
  ],
}

export default MainRoutes
